/* HALE HERBALS — UX fixes (audit 2026-07-20).
   Phase 1 (2026-09-08): the splash loader (html::before) is gone; the
   .hale-atoast helpers are gone (HALE.ui.toast replaced them).
   Phase 2-finish (2026-09-08) — removed here:
   • translateBuyNow() — the unbranded «Buy it now» button is display:none
     (hale-product-v2 §.buybox .pdp-express), so relabelling it was invisible;
     with it went the 20×300 ms polling timer that kept re-applying the label;
   • the image fade (html.hale-imgfade + .hale .pkg img) — the Phase 2 card is
     .hale-card, .pkg survives only as the empty-image placeholder, which has
     no <img> at all, so the selector matched nothing;
   • the mutation observer on document.body that drove both of the above;
   • watchFooter() — it hid the sticky ATC bar with forced inline styles;
     the same rule now lives in hale-product-v2's own stickUpd().
   What is left runs inside window.HALE.ready. */
window.HALE.ready(function () {
  'use strict';

  var H = window.HALE;

  /* 1) Translate the heading on /policies/* pages. Shopify has no theme
     template for them and renders the title itself, always in English. */
  var POLICY_TITLES = {
    'refund-policy': 'Політика повернення',
    'privacy-policy': 'Політика конфіденційності',
    'terms-of-service': 'Умови використання',
    'shipping-policy': 'Політика доставки',
    'subscription-policy': 'Політика передплати',
    'contact-information': 'Контактна інформація',
    'legal-notice': 'Правова інформація'
  };

  H.feature('ux-policy-title', function (doc) {
    var path = window.location.pathname;
    if (path.indexOf('/policies/') === -1) return;
    var handle = (path.split('/policies/')[1] || '').replace(/\/+$/, '');
    var uk = POLICY_TITLES[handle];
    if (!uk) return;
    var h1 = doc.querySelector('.shopify-policy__title h1');
    if (h1 && h1.textContent.trim() !== uk) h1.textContent = uk;
  });

  /* 2) Dispatch window on the product page — REMOVED in Phase B (2026-09-13).
     This used to overwrite [data-shipdate] with a fixed «tomorrow … +3 days»
     window one task after the section had printed its date, which made the
     theme setting «Замовлення до цієї години відправляємо того ж дня»
     (hale_ship_cutoff → HALE.shipCutoff) dead. The window is now printed by
     hale-product-v2 itself, from the cutoff hour. */

  /* 3) Bring the active collection chip into view (CSS half: hale-ux-fixes.css §16). */
  function centreChips() {
    var rails = document.querySelectorAll('.hale .col-wrap .chips');

    for (var i = 0; i < rails.length; i++) {
      var rail = rails[i];
      var on = rail.querySelector('.chip.on');
      if (!on) continue;

      var target = on.offsetLeft - (rail.clientWidth - on.offsetWidth) / 2;
      var max = rail.scrollWidth - rail.clientWidth;
      if (target < 0) target = 0;
      if (target > max) target = max;

      if (!rail.__haleCentred) {
        rail.__haleCentred = true;
        var prev = rail.style.scrollBehavior;
        rail.style.scrollBehavior = 'auto';
        rail.scrollLeft = target;
        rail.style.scrollBehavior = prev;
      } else {
        rail.scrollLeft = target;
      }
    }
  }

  H.feature('ux-centre-chips', function () {
    centreChips();
    if (!window.__haleChipsBound) {
      window.__haleChipsBound = true;
      window.addEventListener('load', centreChips);
      window.addEventListener('resize', centreChips);
    }
  });

  /* 4) Carousel settle (2026-09-18, owner: cards must never rest half-way —
     the same on every .scroller: bestsellers, reviews, cross-sell).
     CSS keeps `scroll-snap-type: x proximity` on mouse/trackpad on purpose
     (mandatory used to hijack the vertical page scroll, see hale-late.css
     «hale-scroll-fix»); touch screens get mandatory there. This closes the
     gap for the trackpad: once a gesture stops (no scroll event for 140 ms,
     and no finger down), the rail glides to the nearest card start. It never
     fights an active gesture and never loops: a settled rail is already
     aligned, so the next check is a no-op. */
  function settleRail(rail) {
    if (rail.__haleTouching) return;
    var kids = rail.children, n = kids.length;
    if (!n) return;
    var x = rail.scrollLeft, max = rail.scrollWidth - rail.clientWidth;
    if (max <= 0) return;
    if (x >= max - 1) return;                       /* resting at the end is fine */
    var best = 0, bestD = Infinity;
    for (var i = 0; i < n; i++) {
      var el = kids[i];
      if (el.offsetWidth === 0) continue;           /* filtered-out cards */
      var d = Math.abs(el.offsetLeft - x);
      if (d < bestD) { bestD = d; best = el.offsetLeft; }
    }
    if (bestD <= 2) return;
    rail.__haleSettling = true;
    rail.scrollTo({ left: Math.min(best, max), behavior: 'smooth' });
    setTimeout(function () { rail.__haleSettling = false; }, 600);
  }

  H.feature('ux-carousel-settle', function (doc) {
    var rails = doc.querySelectorAll('.hale .scroller');
    for (var i = 0; i < rails.length; i++) {
      var rail = rails[i];
      if (rail.__haleSettle) continue;
      rail.__haleSettle = true;
      (function (r) {
        var timer = null;
        r.addEventListener('touchstart', function () { r.__haleTouching = true; }, { passive: true });
        r.addEventListener('touchend', function () { r.__haleTouching = false; clearTimeout(timer); timer = setTimeout(function () { settleRail(r); }, 140); }, { passive: true });
        r.addEventListener('touchcancel', function () { r.__haleTouching = false; }, { passive: true });
        r.addEventListener('scroll', function () {
          if (r.__haleSettling) return;
          clearTimeout(timer);
          timer = setTimeout(function () { settleRail(r); }, 140);
        }, { passive: true });
      })(rail);
    }
  });
});